// Switch the injected provider to the target chain WITHOUT reloading the page.
// If the wallet doesn't know the chain, add it, then switch.

import { ACTIVE } from '../config/networks';

export async function ensureCorrectNetwork(provider) {
  if (!provider) throw new Error('No provider');
  const currentHex = await provider.request({ method: 'eth_chainId' });
  if (currentHex && currentHex.toLowerCase() === ACTIVE.chainIdHex.toLowerCase()) return true;

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: ACTIVE.chainIdHex }]
    });
    return true;
  } catch (err) {
    // 4902 = unknown chain, need to add first
    if (err && (err.code === 4902 || err.code === -32603 || (err.data && err.data.originalError && err.data.originalError.code === 4902))) {
      await provider.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: ACTIVE.chainIdHex,
          chainName: ACTIVE.name,
          nativeCurrency: ACTIVE.nativeCurrency,
          rpcUrls: ACTIVE.rpcUrls,
          blockExplorerUrls: [ACTIVE.explorer]
        }]
      });
      // switch after add (some wallets do this automatically)
      try {
        await provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: ACTIVE.chainIdHex }]
        });
      } catch (_e) { /* some wallets auto-switch on add */ }
      return true;
    }
    throw err;
  }
}

export function isCorrectChainId(chainIdHex) {
  if (!chainIdHex) return false;
  return chainIdHex.toLowerCase() === ACTIVE.chainIdHex.toLowerCase();
}

export function hexToDec(hex) {
  if (!hex) return 0;
  try { return parseInt(hex, 16); } catch (_e) { return 0; }
}
